<template>
  <div id="app">
    <header v-if="showHeader && empresa">
      <app-home-header v-if="isUsuarioLogado()" />
      <menu-dropdown v-if="isUsuarioLogado()" />
    </header>
    <main v-if="empresa && showBackground" :style="styleHeader">
      <router-view></router-view>
      <modal-aceite-termos v-if="isUsuarioLogado()"/>
    </main>
    <footer class="footer" v-if="showFooter && empresa">
      <app-footer />
    </footer>
    <nps v-if='token && empresa' :companyName="empresaNome" :name='nameUsuarioLogado' :baseUrlToAnwserNps='baseUrlToAnwserNps' :baseUrlInitializedNps='baseUrlInitializedNps' :token='token'/>
  </div>
</template>

<script>
import Vue from 'vue'
import AppHomeHeader from '@/components/AppHomeHeader'
import MenuDropdown from '@/components/MenuDropdown'
import AppFooter from '@/components/AppFooter'
import ModalAceiteTermos from '@/components/ModalAceiteTermos'
import i18n from '@/language/i18n'
import LoginUtils from '@/core/utils/login-utils'
import EmpresaUtils from '@/core/utils/empresa-utils'
import TipoAcesso from '@/core/types/tipo-acesso'
import initGtag from './config/gtag'
import initGtm from './config/gtm'
import initRDStation from './config/rdstation'
import * as Sentry from '@sentry/vue'
import Constants from '@/core/constants/constants'

import Nps from '@/modules/Nps/Index'

// import se for usar repositório nps, apagar o import acima
// import Nps from 'nps-jaleko'
// import 'nps-jaleko/dist/npsJaleko.css'

export default {
  name: 'app',
  components: { AppFooter, AppHomeHeader, Nps, ModalAceiteTermos, MenuDropdown },
  data () {
    return {
      showHeader: true,
      showFooter: true,
      showBackground: true,
      footerBackground: '',
      token: null,
      nameUsuarioLogado: null,
      baseUrlToAnwserNps: null,
      baseUrlInitializedNps: null,
      empresaNome: null
    }
  },
  async created () {
    const loader = this.$loading.show()

    Vue.prototype.$tipoAcesso = TipoAcesso
    Vue.prototype.$empresaUtils = EmpresaUtils

    await this.configEmpresa()

    initGtag(this.empresa)
    initGtm(this.empresa)
    initRDStation()

    if (this.$configEmpresa.favicon) {
      const favicon = document.getElementById('favicon')
      favicon.href = `${process.env.VUE_APP_BASE_FILES_URL}empresas/imgs/${process.env.VUE_APP_EMPRESA_REF}/${this.$configEmpresa.favicon}`
    }

    loader.hide()
  },
  computed: {
    empresa: function () {
      return this.$store.getters.empresa
    },
    styleHeader: function () {
      return this.$configEmpresa.headerVersion === Constants.HEADER_VERSION_DEFAULT ? 'margin-top: 0;' : 'margin-top: 57px;'
    }
  },
  methods: {
    isUsuarioLogado: LoginUtils.isUsuarioLogado,
    async configEmpresa () {
      await this.$store.dispatch('empresa')

      document.title = this.$configEmpresa.title

      const ignoredRoutesHeaderFooter = ['not-found', 'release-notes', 'login', 'recuperar-senha', 'redefinir-senha-sem-token', 'redefinir-senha', 'primeiro-acesso-redefinir-senha']

      this.showHeader = !ignoredRoutesHeaderFooter.includes(this.$route.name)
      this.showFooter = !ignoredRoutesHeaderFooter.includes(this.$route.name)
      if (window.location.href.indexOf('login/token') !== -1) {
        this.showHeader = false
        this.showFooter = false
        this.showBackground = false
      }
      i18n.locale = this.$configEmpresa.language

      this.footerBackground = this.$configEmpresa.footerBackgroundColor

      if (this.showHeader) {
        this.baseUrlToAnwserNps = process.env.VUE_APP_JALEKO_BASE_API_URL
        this.baseUrlInitializedNps = window.location.host
        const usuario = LoginUtils.getUsuario()
        if (usuario) {
          Sentry.setUser(usuario)
          this.nameUsuarioLogado = usuario.name
        }
        this.token = LoginUtils.getToken()
        if (this.$configEmpresa.modalNps && this.$configEmpresa.modalNps.empresaNome) {
          this.empresaNome = this.$configEmpresa.modalNps.empresaNome
        } else {
          this.empresaNome = 'o Jaleko'
        }
      }
    }
  }
}
</script>

<style>
</style>
